/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UnreadsResponse } from '../models/UnreadsResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UnreadsService {
    /**
     * Get Unreads
     * @returns UnreadsResponse Successful Response
     * @throws ApiError
     */
    public static getUnreadsApiUnreadsGet(): CancelablePromise<UnreadsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/unreads/',
        });
    }
}
